// extracted by mini-css-extract-plugin
export default {"tableContainer":"SimpleTable_tableContainer__NgamN"};